module.exports = __webpack_public_path__ + "img/contact_banner.20ae99bc.jpg";